import saveIcon from "@assets/images/save-icon-white.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import MyTypography from "@saleor/components/MyTypography";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import {
  InquiryMethodType,
  // useChangeParameterIPlanMutation,
  // usePassParameterToIPlanMutation,
  useUpdateInquiryMethodExportMutation
} from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

interface RouterProps {
  open: boolean;
  allowChangeInquiryMethod?: boolean;
  orderId?: string | null;
  onClose: () => void;
  onSave: (value) => void;
  initialValue?: string;
  isOrderStatusPartialDelivery?: boolean;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 400,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16,
        padding: 24,
        overflow: "auto"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 0 0 0",
        gap: 24
      }
    },
    dialogTitle: {
      padding: 0,
      "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center"
      }
    },
    mainTitle: {
      color: theme.palette.info.main
    },
    closeIcon: {
      marginLeft: "auto",
      cursor: "pointer"
    },
    dialogCenter: {
      padding: "0px !important",
      marginTop: "24px !important",
      "& .MuiFormControl-root": {
        height: 40
      }
    },
    buttonAction: {
      width: "50%",
      height: 48,
      "& svg": {
        marginRight: 10
      }
    },
    nameField: {
      marginBottom: 10
    },
    inputClass: {
      fontSize: 16,
      fontWeight: 400
    },
    menuClass: {
      fontSize: 16,
      fontWeight: 700
    },
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "9px 16px",
      height: 40
    }
  }),
  { name: "ModalResultRoute" }
);

export enum DATA_CHOICE {
  EXPORT = "Export",
  ASAP = "ASAP (Clear stock)"
}

const ModalResultRouter: React.FC<RouterProps> = props => {
  const {
    open,
    onClose,
    onSave,
    initialValue,
    orderId,
    allowChangeInquiryMethod,
    isOrderStatusPartialDelivery
  } = props;
  const classes = useStyles();
  const intl = useIntl();
  const [selectValue, setSelectValue] = useState<string>(initialValue);

  const [inputChoices] = useState([
    {
      label: DATA_CHOICE.EXPORT,
      value: DATA_CHOICE.EXPORT
    },
    {
      label: DATA_CHOICE.ASAP,
      value: InquiryMethodType.ASAP
    }
  ]);

  const handleConverValueToEnum = (value: string): InquiryMethodType => {
    if (value === DATA_CHOICE.EXPORT) {
      return InquiryMethodType.EXPORT;
    }
    if (value === InquiryMethodType.ASAP) {
      return InquiryMethodType.ASAP;
    }
  };

  const [passParameterToIPlan] = useUpdateInquiryMethodExportMutation({
    onCompleted() {
      onClose();
    }
  });

  const handleSave = () => {
    if (orderId) {
      passParameterToIPlan({
        variables: {
          orderLineId: orderId,
          input: {
            inquiryMethod: handleConverValueToEnum(selectValue)
          }
        }
      });
    }
    onSave(selectValue);
  };

  const handleChangeValue = value => {
    setSelectValue(value.target.value);
  };

  return (
    <Dialog className={classes.root} open={open} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>
        <MyTypography variant={"h6"} className={classes.mainTitle}>
          {intl.formatMessage({ defaultMessage: "Input Parameter" })}
        </MyTypography>
        <CloseOutlined className={classes.closeIcon} onClick={onClose} />
      </DialogTitle>
      <DialogContent className={classes.dialogCenter}>
        <MyTypography variant={"subtitle3"} className={classes.nameField}>
          {intl.formatMessage({ defaultMessage: "Inquiry Method" })}
        </MyTypography>
        {allowChangeInquiryMethod && !isOrderStatusPartialDelivery ? (
          <SingleSelectField
            showPlaceHolderWhenSelect
            placeholder={"Select"}
            choices={inputChoices}
            value={selectValue}
            customSelectStyle={{
              fontSize: "16px",
              textColor: "#007E92",
              menuClass: classes.menuClass,
              inputClass: classes.inputClass
            }}
            onChange={handleChangeValue}
          />
        ) : (
          <MyTypography variant="body3" className={classes.boxBackground}>
            {selectValue}
          </MyTypography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onClose}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({ defaultMessage: "ปิดหน้าต่าง" })}
          </MyTypography>
        </Button>
        <Button
          variant={"contained"}
          color={"secondary"}
          onClick={handleSave}
          className={classes.buttonAction}
          disabled={!allowChangeInquiryMethod || isOrderStatusPartialDelivery}
        >
          <SVG src={saveIcon} />
          <MyTypography variant={"body2"}>
            {intl.formatMessage({ defaultMessage: "บันทึก" })}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalResultRouter;
